import fetcher from 'api/fetcher';

import urlParser from 'bloko/common/urlParser';

import { CampaignsCounts, setCampaignsCounts } from 'store/models/campaignsDashboard';
import { AppliedCampaignsFilters } from 'store/models/campaignsFilters';
import { AppThunkAction } from 'store/utils';

export const fetchCampaignsCount = ({
    abortSignal,
    searchValue,
    filters,
}: {
    abortSignal: AbortSignal;
    searchValue?: string;
    filters?: AppliedCampaignsFilters;
}): AppThunkAction => {
    return (dispatch, getState) => {
        const appliedCampaignsFilters =
            filters === undefined ? getState().campaignsFilters.appliedCampaignsFilters : filters;

        const nameFilter = searchValue === undefined ? getState().campaignsFilters.campaignsSearchValue : searchValue;

        const {
            productTypes,
            campaignStatuses,
            budgetStatuses,
            moderationStatuses,
            areas,
            professionalRoles,
            createdByUserIds,
        } = appliedCampaignsFilters;

        const queryStr = urlParser.stringify({
            nameFilter,
            productType: [...productTypes],
            campaignStatus: [...campaignStatuses],
            budgetStatus: [...budgetStatuses],
            moderationStatus: [...moderationStatuses],
            area: [...areas],
            professionalRoles: [...professionalRoles],
            createdByUserIds: [...createdByUserIds],
        });

        return fetcher
            .get<unknown, CampaignsCounts>(`/api/v2/campaigns/count?${queryStr}`, {
                signal: abortSignal,
                timeout: 30000,
            })
            .then((campaignCounts) => {
                dispatch(setCampaignsCounts(campaignCounts));
            });
    };
};
